<div class="row banner banner-homepage" appParallax>
    <div class="col-lg-5 col-md-7 justify-content-center align-self-center">
        <h1>We are <strong>mercit</strong></h1>
        <p>
            We help you envision and create a digital environment to communicate your company’s
            identity with its stakeholders, leading them to a better understanding of your business
            and connecting them to your value at all times.
        </p>
        <div>
            <a routerLink="/contact" class="btn btn-primary">Contact us</a>
        </div>
    </div>
    <a class="btn scroll-down d-none "><i class="fa fa-angle-right" aria-hidden="true"></i></a>
    <img appParallax [config]="{
        cssProperty: 'transform:translate',
        parallaxRatio: 40,
        initialValue: '70'
    }" class="asset-rocket" src="/assets/img/rocket.png" alt="rocket">
    <img appParallax [config]="{
        cssProperty: 'bottom',
        parallaxRatio: 20
    }" class="asset-moon" src="/assets/img/moon.png" alt="moon">
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/home/home.component.html